import React from "react";
import styled, { css } from "styled-components";

import WaveLeft from "../../../static/images/wave-left.svg";
import WaveBottom from "../../../static/images/wave-bottom.svg";

const Mask = ({ children, side }) => (
  <MaskWrapper side={side}>
    <span className="waves">
      <WaveLeft className="left" />
      <WaveBottom className="bottom" />
    </span>
    {children}
  </MaskWrapper>
);

const MaskWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 100%;
  & > span.waves {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    svg {
      position: absolute;
      &.left,
      &.right,
      &.bottom,
      &.top {
        display: none;
        width: auto;
      }
      &.left {
        height: 100%;
        left: 0;
      }
      &.bottom {
        width: 100%;
        bottom: 0;
      }
      ${(props) => {
        if (props.side === "left") {
          return css`
            &.left {
              display: block;
            }
            @media (max-width: 45em) {
              &.left {
                display: none;
              }
              &.bottom {
                display: block;
              }
            }
          `;
        }
      }}
      path {
        fill: ${(props) => props.theme.colors.white["900"]};
      }
    }
  }
`;

export default Mask;
